var data = `date,close,volume,open,high,low
16:00,230.75,5,564,200,231.88,232.50,225.75
2019/08/06,230.7500,5564200.0000,231.8800,232.5000,225.7500
2019/08/05,228.3200,7028279.0000,229.6000,231.3673,225.7750
2019/08/02,234.3400,6136481.0000,231.3500,236.2700,229.2300
2019/08/01,233.8500,8259516.0000,242.6500,244.5100,231.7700
2019/07/31,241.6100,9178208.0000,243.0000,246.6800,236.6501
2019/07/30,242.2600,8109014.0000,232.9000,243.3600,232.1800
2019/07/29,235.7700,9273331.0000,227.0900,235.9400,226.0325
2019/07/26,228.0400,10027700.0000,226.9200,230.2600,222.2500
2019/07/25,228.8200,22418250.0000,233.5000,234.5000,225.5501
2019/07/24,264.8800,11072840.0000,259.1700,266.0700,258.1601
2019/07/23,260.1700,5023121.0000,256.7100,260.4800,254.5000
2019/07/22,255.6800,6846273.0000,258.7500,262.1550,254.1911
2019/07/19,258.1800,7048410.0000,255.6900,259.9600,254.6200
2019/07/18,253.5400,4764483.0000,255.0500,255.7500,251.8850
2019/07/17,254.8600,9764727.0000,255.6700,258.3100,253.3500
2019/07/16,252.3800,8148989.0000,249.3000,253.5300,247.9325
2019/07/15,253.5000,11000090.0000,248.0000,254.4200,244.8600
2019/07/12,245.0800,9200521.0000,239.7500,245.3800,239.7100
2019/07/11,238.6000,7514430.0000,238.1400,241.5000,235.8000
2019/07/10,238.9200,9145736.0000,234.1500,238.9400,233.1400
2019/07/09,230.0600,6190835.0000,228.9700,231.0000,227.2800
2019/07/08,230.3400,5880542.0000,231.2400,232.2500,228.6600
2019/07/05,233.1000,7065738.0000,234.5700,235.4500,230.8000
2019/07/03,234.9000,14201150.0000,239.3900,241.5700,234.5100
2019/07/02,224.5500,9259027.0000,228.8900,229.1500,222.2200
2019/07/01,227.1700,8237964.0000,230.2100,233.0995,226.2800
2019/06/28,223.4600,6851384.0000,220.9900,225.1700,220.8000
2019/06/27,222.8400,6339710.0000,219.4500,222.9000,217.3500
2019/06/26,219.2700,8507208.0000,220.3100,227.2300,218.1000
2019/06/25,219.7600,6182071.0000,224.3900,225.3400,219.4900
2019/06/24,223.6400,5750771.0000,223.2400,225.8600,221.0200
2019/06/21,221.8600,8202078.0000,216.2200,222.1800,215.5000
2019/06/20,219.6200,11863460.0000,223.0000,226.9000,216.3500
2019/06/19,226.4300,6575135.0000,225.1100,227.7700,221.0600
2019/06/18,224.7400,12715790.0000,228.7200,234.7400,222.5600
2019/06/17,225.0300,12316800.0000,215.4800,227.0000,214.2700
2019/06/14,214.9200,7433402.0000,211.2500,216.6500,210.4000
2019/06/13,213.9100,8168260.0000,210.3800,214.9000,207.5103
2019/06/12,209.2600,15197540.0000,222.9500,223.3800,209.0000
2019/06/11,217.1000,11653540.0000,219.1440,220.9000,213.5000
2019/06/10,212.8800,10585040.0000,210.2500,216.9400,209.0100
2019/06/07,204.5000,16003530.0000,205.0000,210.8438,203.4990
2019/06/06,205.9500,20242150.0000,204.4400,211.0000,201.8000
2019/06/05,196.5900,13510760.0000,198.6800,201.2782,191.8486
2019/06/04,193.6000,13807520.0000,181.1000,193.9800,179.6100
2019/06/03,178.9700,13064410.0000,185.5100,186.6800,176.9919
2019/05/31,185.1600,10406730.0000,185.1000,189.9204,184.1000
2019/05/30,188.2200,7926475.0000,188.7500,192.2550,187.0200
2019/05/29,189.8600,11968640.0000,187.1000,192.3900,185.0401
2019/05/28,188.7000,10312900.0000,191.2000,195.0000,187.8500
2019/05/24,190.6300,14136570.0000,199.8300,199.9800,188.7505
2019/05/23,195.4900,26547140.0000,194.3400,199.4650,186.2200
2019/05/22,192.7300,18685190.0000,199.1000,203.9400,191.7800
2019/05/21,205.0800,18003900.0000,197.7600,207.4000,196.0400
2019/05/20,205.3600,20526200.0000,202.8000,206.0000,195.2500
2019/05/17,211.0300,17786670.0000,221.9600,222.2400,208.9200
2019/05/16,228.3300,7483273.0000,229.4900,231.0000,226.5000
2019/05/15,231.9500,7295976.0000,229.3200,232.4400,225.2500
2019/05/14,232.3100,7252412.0000,229.3000,234.5000,228.0000
2019/05/13,227.0100,10834800.0000,232.0100,232.4700,224.5000
2019/05/10,239.5200,7008336.0000,239.7500,241.9900,236.0200
2019/05/09,241.9800,6711382.0000,242.0000,243.6800,236.9434
2019/05/08,244.8400,6176440.0000,246.9400,250.5990,244.2000
2019/05/07,247.0600,10131410.0000,256.8000,257.2100,245.1000
2019/05/06,255.3400,10833940.0000,250.0200,258.3499,248.5000
2019/05/03,255.0300,23706770.0000,243.8600,256.6100,243.4900
2019/05/02,244.1000,18159340.0000,245.5200,247.1300,237.7200
2019/05/01,234.0100,10704350.0000,238.8500,240.0000,231.5000
2019/04/30,238.6900,9446965.0000,242.0600,244.2100,237.0000
2019/04/29,241.4700,16686620.0000,235.8600,243.9800,232.1700
2019/04/26,235.1400,22151160.0000,246.5000,246.6800,231.1300
2019/04/25,247.6300,21823380.0000,255.0000,259.0000,246.0700
2019/04/24,258.6600,9657061.0000,263.8500,265.3200,258.0000
2019/04/23,263.9000,10909350.0000,260.1500,265.6000,255.7500
2019/04/22,262.7500,12101690.0000,269.0000,269.6800,262.4800
2019/04/18,273.2600,5861478.0000,271.2300,274.8400,269.7500
2019/04/17,271.2300,5118011.0000,274.7500,274.7900,268.5350
2019/04/16,273.3600,7266504.0000,265.7500,275.0000,264.7200
2019/04/15,266.3800,10032490.0000,268.6300,268.8800,258.6300
2019/04/12,267.7000,6735386.0000,270.2200,271.9500,266.8300
2019/04/11,268.4200,9781294.0000,268.3000,270.5000,265.6000
2019/04/10,276.0600,7045034.0000,276.7400,278.3800,272.8925
2019/04/09,272.3100,5893247.0000,271.6500,275.0000,269.6100
2019/04/08,273.2000,10364600.0000,277.6900,281.1600,270.4400
2019/04/05,274.9600,13022740.0000,269.8600,276.1000,266.1100
2019/04/04,267.7800,23680170.0000,261.8900,271.2000,260.5900
2019/04/03,291.8100,7916650.0000,287.3200,296.1700,287.1700
2019/04/02,285.8800,5427184.0000,288.3000,289.4400,283.8800
2019/04/01,289.1800,8093134.0000,282.6200,289.2000,281.2810
2019/03/29,279.8600,5980355.0000,278.7000,280.1600,274.5000
2019/03/28,278.6200,6764921.0000,277.1600,280.3300,275.1000
2019/03/27,274.8300,8752384.0000,268.7500,275.3700,268.1838
2019/03/26,267.7700,7341868.0000,264.4400,270.2600,264.4300
2019/03/25,260.4200,10205080.0000,259.7100,263.1800,254.4600
2019/03/22,264.5300,8721950.0000,272.5800,272.8000,264.0000
2019/03/21,274.0200,5930925.0000,272.6000,276.4500,268.4500
2019/03/20,273.6000,6881976.0000,269.6900,274.9700,266.3000
2019/03/19,267.4700,11774330.0000,267.5000,273.3000,263.4600
2019/03/18,269.4900,10264960.0000,276.0000,278.0500,267.3000
2019/03/15,275.4300,14757360.0000,283.5100,283.7244,274.4000
2019/03/14,289.9600,7048138.0000,292.4500,295.3900,288.2900
2019/03/13,288.9600,6817854.0000,283.9000,291.9900,282.7000
2019/03/12,283.3600,7488037.0000,286.4900,288.0700,281.0600
2019/03/11,290.9200,7372298.0000,283.5200,291.2800,280.5000
2019/03/08,284.1400,8805772.0000,276.9100,285.5900,275.8900
2019/03/07,276.5900,9410697.0000,278.8400,284.7000,274.2500
2019/03/06,276.2400,10319370.0000,276.4800,281.5058,274.3900
2019/03/05,276.5400,18729800.0000,282.0000,284.0000,270.1000
2019/03/04,285.3600,17068890.0000,298.1200,299.0000,282.7800
2019/03/01,294.7900,22848750.0000,306.9400,307.1300,291.9000
2019/02/28,319.8800,9666224.0000,318.9200,320.0000,310.8100
2019/02/27,314.7400,11144100.0000,301.7800,316.2950,300.5500
2019/02/26,297.8600,8571609.0000,292.2200,302.0100,288.7701
2019/02/25,298.7700,6213701.0000,297.9100,302.9044,297.0005
2019/02/22,294.7100,5731380.0000,294.4900,296.5000,292.1000
2019/02/21,291.2300,8880830.0000,301.8100,303.2399,290.5000
2019/02/20,302.5600,7132969.0000,304.4100,306.3000,299.0000
2019/02/19,305.6400,4120520.0000,306.5600,311.5442,305.4700
2019/02/15,307.8800,3895815.0000,304.5000,308.0000,303.9000
2019/02/14,303.7700,5190887.0000,303.3800,306.7700,301.0000
2019/02/13,308.1700,5130398.0000,312.3500,312.7500,305.5700
2019/02/12,311.8100,5485419.0000,316.2000,318.1900,309.6200
2019/02/11,312.8400,7114012.0000,311.6000,318.6000,310.5000
2019/02/08,305.8000,5835078.0000,306.8300,307.4450,298.5000
2019/02/07,307.5100,6511830.0000,313.3000,314.7000,303.0000
2019/02/06,317.2200,5031368.0000,319.5900,324.2400,315.6240
2019/02/05,321.3500,6734739.0000,312.4900,322.4400,312.2494
2019/02/04,312.8900,7344076.0000,312.9800,315.3000,301.8800
2019/02/01,312.2100,7263618.0000,305.4200,316.1000,303.5000
2019/01/31,307.0200,12545190.0000,301.0000,311.5636,294.0000
2019/01/30,308.7700,10594040.0000,300.4500,309.0000,298.4900
2019/01/29,297.4600,4602933.0000,295.2700,298.5566,291.8000
2019/01/28,296.3800,6409477.0000,292.9100,297.4600,287.7500
2019/01/25,297.0400,7102781.0000,294.3900,298.5195,289.5500
2019/01/24,291.5100,7990911.0000,283.0300,293.6800,279.2831
2019/01/23,287.5900,12513080.0000,292.5000,294.5000,281.6900
2019/01/22,298.9200,12052130.0000,304.8200,308.0000,295.5000
2019/01/18,302.2600,24079260.0000,323.0000,327.1297,299.7301
2019/01/17,347.3100,3661162.0000,346.2100,351.5000,344.1500
2019/01/16,346.0500,4677227.0000,344.7800,352.0000,343.5000
2019/01/15,344.4300,6047890.0000,335.0000,348.8000,334.5000
2019/01/14,334.4000,5232690.0000,342.3800,342.5000,334.0000
2019/01/11,347.2600,5035078.0000,342.0900,348.4100,338.7700
2019/01/10,344.9700,6049621.0000,334.4000,345.3900,331.7900
2019/01/09,338.5300,5426618.0000,335.5000,343.5025,331.4700
2019/01/08,335.3500,6994427.0000,341.9600,344.0100,327.0200
2019/01/07,334.9600,7542338.0000,321.7200,336.7400,317.7508
2019/01/04,317.6900,7382755.0000,306.0000,318.0000,302.7300
2019/01/03,300.3600,6948577.0000,307.0000,309.4000,297.3800
2019/01/02,310.1200,11611270.0000,306.1000,315.1300,298.8000
2018/12/31,332.8000,6294298.0000,337.7900,339.2100,325.2600
2018/12/28,333.8700,9918777.0000,323.1000,336.2400,318.4100
2018/12/27,316.1300,8567385.0000,319.8400,322.1717,301.5000
2018/12/26,326.0900,8143102.0000,300.0000,326.9700,294.0900
2018/12/24,295.3900,5559913.0000,313.5000,314.5000,295.1950
2018/12/21,319.7700,7997219.0000,317.4000,323.4700,312.4400
2018/12/20,315.3800,9049389.0000,327.0540,330.2900,311.8690
2018/12/19,332.9700,8256374.0000,337.6000,347.0100,329.7400
2018/12/18,337.0300,7084887.0000,350.5400,351.5500,333.6900
2018/12/17,348.4200,7664832.0000,362.0000,365.7000,343.8800
2018/12/14,365.7100,6327625.0000,375.0000,377.8700,364.3300
2018/12/13,376.7900,7348168.0000,370.1500,377.4400,366.7500
2018/12/12,366.6000,5019725.0000,369.4200,371.9100,365.1600
2018/12/11,366.7600,6298472.0000,369.9100,372.1689,360.2300
2018/12/10,365.1500,6575341.0000,360.0000,365.9800,353.1200
2018/12/07,357.9650,11484350.0000,369.0000,379.4900,357.6500
2018/12/06,363.0600,7828689.0000,356.0100,367.3800,350.7600
2018/12/04,359.7000,8430213.0000,356.0500,368.6800,352.0000
2018/12/03,358.4900,8295843.0000,360.0000,366.0000,352.0000
2018/11/30,350.4800,5621104.0000,341.8300,351.6000,338.2648
2018/11/29,341.1700,3076026.0000,347.0000,347.5000,339.5500
2018/11/28,347.8700,4114038.0000,345.9900,348.2800,342.2100
2018/11/27,343.9200,6347004.0000,340.0500,346.9600,335.5000
2018/11/26,346.0000,7973119.0000,325.0000,346.2200,325.0000
2018/11/23,325.8300,4202642.0000,334.3450,337.5000,325.5500
2018/11/21,338.1900,4677389.0000,352.0000,353.1000,337.3995
2018/11/20,347.4900,7991253.0000,341.7500,349.8000,333.5500
2018/11/19,353.4700,9698559.0000,356.3400,366.7500,352.8800
2018/11/16,354.3100,7194458.0000,345.1900,355.7000,345.1201
2018/11/15,348.4400,4600130.0000,342.3300,348.5800,339.0400
2018/11/14,344.0000,5032083.0000,342.7000,347.1100,337.1500
2018/11/13,338.7300,5422756.0000,333.1600,344.7000,332.2000
2018/11/12,331.2800,6916965.0000,348.3700,349.7800,330.3400
2018/11/09,350.5100,5093456.0000,349.0000,354.0000,345.2300
2018/11/08,351.4000,7080203.0000,348.5000,357.5755,348.4400
2018/11/07,348.1600,7366706.0000,343.3400,351.1800,340.8000
2018/11/06,341.0600,6751930.0000,339.0700,348.8000,336.0900
2018/11/05,341.4000,7820845.0000,340.5000,343.9550,330.1400
2018/11/02,346.4100,7799920.0000,343.7400,349.2000,340.9100
2018/11/01,344.2800,7980946.0000,338.2600,347.8400,334.7250
2018/10/31,337.3200,7600840.0000,332.5400,342.0000,329.1000
2018/10/30,329.9000,9109120.0000,328.3900,337.8999,322.2600
2018/10/29,334.8500,14455150.0000,337.4700,347.1600,326.5000
2018/10/26,330.9000,27380220.0000,308.2500,339.9000,306.6500
2018/10/25,314.8600,20771670.0000,317.2200,321.0000,301.0100
2018/10/24,288.5000,19350450.0000,301.0500,304.4400,285.7300
2018/10/23,294.1400,18956210.0000,263.8700,297.9300,262.1000
2018/10/22,260.9500,5594855.0000,260.6800,261.8600,252.5900
2018/10/19,260.0000,9344764.0000,267.3900,269.6600,253.5000
2018/10/18,263.9100,5401871.0000,269.2900,271.0000,263.0000
2018/10/17,271.7800,8636949.0000,282.4000,282.7000,265.8032
2018/10/16,276.5900,9501120.0000,265.7000,277.3750,262.2400
2018/10/15,259.5900,6189026.0000,259.0600,263.2800,254.5367
2018/10/12,258.7800,7189257.0000,261.0000,261.9900,252.0100
2018/10/11,252.2300,8128184.0000,257.5300,262.2500,249.0300
2018/10/10,256.8800,12781560.0000,264.6100,265.5100,247.7700
2018/10/09,262.8000,12037780.0000,255.2500,266.7700,253.3000
2018/10/08,250.5600,13371180.0000,264.5200,267.7599,249.0000
2018/10/05,261.9500,17900710.0000,274.6500,274.8800,260.0000
2018/10/04,281.8300,9638885.0000,293.9500,294.0000,277.6700
2018/10/03,294.8000,7982272.0000,303.3300,304.6000,291.5700
2018/10/02,301.0200,11699690.0000,313.9500,316.8400,299.1500
2018/10/01,310.7000,21714210.0000,305.7700,311.4400,301.0500
2018/09/28,264.7700,33597290.0000,270.2600,278.0000,260.5550
2018/09/27,307.5200,7337760.0000,312.9000,314.9600,306.9100
2018/09/26,309.5800,7835863.0000,301.9100,313.8900,301.1093
2018/09/25,300.9900,4472287.0000,300.0000,304.6000,296.5000
2018/09/24,299.6800,4834384.0000,298.4800,302.9993,293.5800
2018/09/21,299.1000,5038497.0000,297.7000,300.5800,295.3700
2018/09/20,298.3300,7332477.0000,303.5600,305.9800,293.3300
2018/09/19,299.0200,8264353.0000,280.5100,300.0000,280.5000
2018/09/18,284.9600,16494280.0000,296.6900,302.6400,275.5000
2018/09/17,294.8400,6866208.0000,290.0400,300.8700,288.1300
2018/09/14,295.2000,6757652.0000,288.7600,297.3256,286.5200
2018/09/13,289.4600,6333281.0000,288.0200,295.0000,285.1800
2018/09/12,290.5400,10002150.0000,281.4400,292.5000,278.6463
2018/09/11,279.4400,9161061.0000,279.4700,282.0000,273.5500
2018/09/10,285.5000,14232250.0000,273.2600,286.0300,271.0000
2018/09/07,263.2400,22442310.0000,260.1000,268.3500,252.2548
2018/09/06,280.9500,7472756.0000,284.8000,291.1700,278.8800
2018/09/05,280.7400,7707342.0000,285.0500,286.7800,277.1800
2018/09/04,288.9500,8304571.0000,296.9400,298.1900,288.0000
2018/08/31,301.6600,5367048.0000,302.0000,305.3082,298.6000
2018/08/30,303.1500,7210625.0000,302.2600,304.6000,297.7200
2018/08/29,305.0100,7410538.0000,310.2700,311.8500,303.6900
2018/08/28,311.8600,7639453.0000,318.4100,318.8800,311.1900
2018/08/27,319.2700,13062650.0000,318.0000,322.4350,308.8100
2018/08/24,322.8200,3592734.0000,320.7000,323.8500,319.4000
2018/08/23,320.1000,5138685.0000,319.1400,327.3200,318.1000
2018/08/22,321.6400,5935853.0000,320.8700,323.8800,314.6700
2018/08/21,321.9000,13147770.0000,310.6100,324.7900,309.0000
2018/08/20,308.4400,17380430.0000,291.7040,308.5000,288.2000
2018/08/17,305.5000,18895880.0000,323.5000,326.7700,303.5300
2018/08/16,335.4500,6045392.0000,339.9100,342.2800,333.8200
2018/08/15,338.6900,9073033.0000,341.9060,344.4900,332.1400
2018/08/14,347.6400,6948511.0000,358.4500,359.1995,347.1000
2018/08/13,356.4100,10444920.0000,361.1300,363.1900,349.0200
2018/08/10,355.4900,11530510.0000,354.0000,360.0000,346.0000
2018/08/09,352.4500,16951800.0000,365.5500,367.0100,345.7300
2018/08/08,370.3400,24535420.0000,369.0900,382.6400,367.1200
2018/08/07,379.5700,30596400.0000,343.8400,387.4600,339.1501
2018/08/06,341.9900,8536766.0000,345.4600,354.9800,341.8200`

export default data;